import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["field"]

  connect() {
    let params = new URLSearchParams(window.location.search);
    let zipcode = params.get('zipcode');
    this.fieldTarget.value = zipcode;
  }
}
